export const FIELD_PRODUCT_ERROR = 'productError';
